import actions from '~/store/modules/shared/classifieds/search/actions'
import mutations from '~/store/modules/shared/classifieds/search/mutations'
import getters from '~/store/modules/shared/classifieds/search/getters'
import state from '~/store/modules/shared/classifieds/search/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  mutations,
  getters,
  state
})
